import React from 'react';
import { useTranslation } from 'react-i18next';
import PhotoCameraIcon from '@mui/icons-material/PhotoCameraOutlined';
import { Stack, Typography } from '@mui/material';
import { CheckBox } from '@mui/icons-material';

import Button from '@ui-lib/components/Button';
import Card from '@ui-lib/components/Card';
import { createSx } from '@ui-lib/utils';
import AddPhotoModal from '../../../../../components/AddPhoto/components/AddPhotoModal';

import { useAddPhoto } from '../../../../../components/AddPhoto/hooks/useAddPhoto';
import { CameraError } from '../../../../../components/AddPhoto/components/CameraError';
import { PHOTO_TYPE } from '../../../../../api/types/PhotoType';
import { useBolAuthToken } from './DeliveryTokenContext';

const sx = createSx({
  container: {
    width: '100%',
    alignSelf: 'center',
    boxSizing: 'border-box',
  }
});

interface Props {
  setPhoto: (photo: string) => void;
}

export const AddPodButton = (({ setPhoto }: Props) => {
  const { t } = useTranslation();
  const token = useBolAuthToken();

  const {
    open,
    handleModalStateChange,
    cameraError,
    setCameraError,
    loading,
    savePhoto,
    openCamera,
  } = useAddPhoto(setPhoto, PHOTO_TYPE.ACTUAL);

  if (!token) return null;

  return (
    <>
      <Stack sx={sx.container} spacing={2} paddingTop={1}>
        <Card testID='photo-field' >
          <Stack alignItems='center' gap={1}>
            {cameraError ? (
              <CameraError 
                errorMessage={cameraError} 
                onRetry={handleModalStateChange}
              />
            ) : (
              <>
                <CheckBox fontSize='large' color='primary' />
                <Typography variant='body2' gutterBottom textAlign='center'>
                  {t('bolCreatePage_podDescription')}
                </Typography>
                <Button
                  variant='tonal'
                  fullWidth
                  loading={loading}
                  onClick={openCamera}
                  startIcon={<PhotoCameraIcon />}
                >
                  {t('bolCreatePage_addPodPhoto')}
                </Button>
              </>
            )}
          </Stack>
        </Card>
      </Stack>
      <AddPhotoModal
        open={open}
        onClose={handleModalStateChange}
        onCapture={(imageSrc) => savePhoto(token, imageSrc)}
        cameraError={cameraError}
        setCameraError={setCameraError}
      />
    </>
  );
});
